import picVideo from './pic&video'
export default {
  components: { picVideo },
  data() {
    return {
      rowData: {},
      viewType: '',
    }
  },
  methods: {
    showDialog(rowData, type) {
      // this.rowData = rowData;
      // this.viewType = type;
      this.$refs['picVideo'].showDialog(rowData, type);
    }
  }
}